export enum AuthMutationsTypesEnum {
  UPDATE_AUTH_STATUS= 'UPDATE_AUTH_STATUS',
}
